import type { ApiClient } from '@carbonwebmail/api-client'
import type { SegmentListDto } from '@carbonwebmail/contracts'
import { useCallback } from 'react'
import { useLoaded } from '../../ui/useLoaded.js'

/**
 * The segments an organisation has, and nothing else.
 *
 * Two screens want this and want different amounts of it. The segments board
 * arranges them — search, order, ticks, a menu per row — and the contacts board
 * only needs the names, to offer them in the "connect to a segment" picker.
 *
 * Split out so the picker does not carry a board's worth of machinery, and so
 * that "which segments are there" is still asked in one place: `useSegments`
 * builds on this rather than fetching for itself.
 */
export function useSegmentList({ client }: { readonly client: ApiClient }) {
  const load = useCallback(() => client.segments(), [client])

  return useLoaded<SegmentListDto>(
    load,
    'We could not load your segments. Please try again in a moment.',
  )
}
